// cs2636 (Almar, 03/11): o botão "Anuncie Seu Imóvel" da seção institucional da home (OwnersPieces,
// "Quem somos"/Nossa empresa) leva à página do FORMULÁRIO "Anuncie seu imóvel" que o próprio cliente criou
// nas Páginas do Site — em vez de abrir o WhatsApp do anuncie. (A 1ª versão, 16256656, mandava para a
// calculadora "Avalie seu imóvel"; o pedido da cliente era o formulário.)
// Pedido de um cliente só = gate por codsite: fora daqui o botão segue no WhatsApp, como antes.
// Os demais "Anuncie" do site (menu, card "Anuncie Agora", rodapé) não mudam.
const ANUNCIE_VAI_PARA_PAGINA_DO_SITE = new Set<number>([2636]);

// Mesma rota do link "Anuncie seu imóvel" do rodapé (/menu/<título da página>).
export const ANUNCIE_PAGINA_ROTA = '/menu/Anuncie%20seu%20im%C3%B3vel';

export const anuncieVaiParaPaginaDoSite = (site: any): boolean =>
    ANUNCIE_VAI_PARA_PAGINA_DO_SITE.has(Number(site?.id));
